import { Reducer } from "redux";

import { DocumentTypeResponse } from "../models/Api/Master";
import { DocumentTypeDispatchTypes } from "../models/DispatchTypes/Master";
import { DocumentTypeActionDispatchTypes } from "../constants/Master";

const initialState: DocumentTypeResponse = {
  loading: false,
  response: [],
};

const DocumentTypeReducer: Reducer<
  DocumentTypeResponse,
  DocumentTypeDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DocumentTypeActionDispatchTypes.GET_DOCUMENT_TYPE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DocumentTypeActionDispatchTypes.GET_DOCUMENT_TYPE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case DocumentTypeActionDispatchTypes.GET_DOCUMENT_TYPE_ERROR: {
      return initialState;
    }
    case DocumentTypeActionDispatchTypes.GET_DOCUMENT_TYPE_RESET: {
      return initialState;
    }
  }
  
  return state;
};

export default DocumentTypeReducer;
